export enum EScreenMedia {
  xs = 0,
  sm = 1,
  md = 2,
  lg = 3,
  xl = 4
}
